<template>
  <transition-group
    name="meeting-type-icons"
    tag="div"
    class="meeting-type-icons"
  >
    <div
      v-for="meetingType in iconMeetingTypes"
      :key="meetingType"
      :title="meetingType"
      class="meeting-type-icons__icon-wrapper"
    >
      <p v-if="!meetingType">
        {{ meetingType }}
      </p>
      <svg v-else class="meeting-type-icons__icon">
        <use :xlink:href="`#${meetingType}`" />
      </svg>
    </div>
  </transition-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { MEETING_TYPE_KEYS } from 'Constants/meetingTypes';
import { meetingTypeBucketForRole } from 'Main/contact-form/constants';

export default defineComponent({
  name: 'MeetingTypeIcons',

  data() {
    return {
      role: this.$root.$data.role,
      defaultRole: this.$root.$data.defaultRole,
      icons: {
        [MEETING_TYPE_KEYS.IN_PERSON]: 'meeting-location-pin',
        [MEETING_TYPE_KEYS.VIDEO]: 'meeting-video',
        [MEETING_TYPE_KEYS.PHONE]: 'meeting-phone',
      },
    };
  },

  computed: {
    ...mapState('user', ['availableMeetingTypes']),

    isActiveRole() {
      return this.role === this.defaultRole;
    },

    iconMeetingTypes() {
      if (!this.meetingTypes || Object.keys(this.meetingTypes).length === 0) {
        return [];
      }

      return Object.keys(this.meetingTypes)
        .map((meetingTypeKey) => {
          if (
            meetingTypeKey !== MEETING_TYPE_KEYS.AT_OUR_OFFICES &&
            meetingTypeKey !== MEETING_TYPE_KEYS.AT_CLIENTS_HOME
          ) {
            return this.icons[meetingTypeKey];
          }

          if (meetingTypeKey === MEETING_TYPE_KEYS.AT_OUR_OFFICES) {
            return this.icons[MEETING_TYPE_KEYS.IN_PERSON];
          }

          return null;
        })
        .filter((meetingType) => meetingType !== null);
    },

    meetingTypes() {
      return this.availableMeetingTypes[meetingTypeBucketForRole(this.role)];
    },
  },
});
</script>
